import axios from "axios";
import { useState } from "react";

const fileData = (newFile) => {
  const data = new FormData();
  data.append("file", newFile);

  return data;
};

const useFileImport = (onSuccess, onFailure) => {
  const statuses = {
    IDLE: "idle",
    IMPORT_FAILURE: "failure",
    IMPORT_SUCCESS: "success",
    RUNNING: "running",
  };
  const [status, setStatus] = useState(statuses.IDLE);
  const resetStatus = () => setStatus(statuses.IDLE);

  const importFile = (file, url) => {
    setStatus(statuses.RUNNING);

    axios
      .post(url, fileData(file), {
        headers: { "content-type": "multipart/form-data" },
        withCredentials: true,
      })
      .then((response) => {
        if (response.data.errors?.length) {
          setStatus(statuses.IMPORT_FAILURE);
          onFailure(response.data.errors);
        } else {
          setStatus(statuses.IMPORT_SUCCESS);
          onSuccess(response);
        }
      })
      .catch(() => {
        setStatus(statuses.IMPORT_FAILURE);
        onFailure(["Error..."]);
      });
  };

  return [status, resetStatus, importFile];
};

export default useFileImport;
